import showdown from 'showdown';
import TurndownService from 'turndown';
import { DIRECTION, RTL_LANGUAGES_REX } from '../constants/constants';
import showdownKatex from './showdown-katex';
export const convertMarkdownToHTML = (markdown: string) => {
  const converter = new showdown.Converter({
    strikethrough: false,
    extensions: [showdownKatex()]
  });
  converter.setOption('simpleLineBreaks', true);
  const html = converter.makeHtml(markdown);
  if (!html) return html;
  return html.replaceAll(/(~~)(.+?)(~~)/gi, '<s>$2</s>'); // handle strikethrough
};
export const convertHtmlToMarkdown = (html: string) => {
  const turndownService = new TurndownService({
    headingStyle: 'atx',
    codeBlockStyle: 'indented',
    fence: '```'
  }).addRule('strikethrough', {
    filter: ['del', 's'],
    replacement: function (content: string) {
      return '~~' + content + '~~';
    }
  }).addRule('codeblock', {
    filter: ['pre'],
    replacement: function (content: string) {
      // remove starting and ending new line chars
      return '```\n' + content.replace(/\^n+|\n+$/, '') + '\n```';
    }
  });
  return turndownService.turndown(html);
};

// Function to detect the language of the content
export const detectLanguageDirection = (content: string) => {
  if (!content) return DIRECTION.LTR;
  if (content.match(RTL_LANGUAGES_REX)) {
    return DIRECTION.RTL; // RTL language detected
  } else {
    return DIRECTION.LTR; // LTR language detected
  }
};
export const getWordCount = (text: string) => {
  if (!text || !text.trim()) return 0;
  // Remove leading and trailing whitespace and split the text into words
  const words = text.trim().split(/\s+/);
  // Return the number of words
  return words.length;
};